import { NgModule } from '@angular/core';
import { OpportunityNotesComponent } from './opportunity-notes.component';
import { OpportunityNotesEditComponent } from './opportunity-notes-edit.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { EmptyStateModule } from '@vendasta/uikit';
import { FormsModule } from '@angular/forms';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { MatIconModule } from '@angular/material/icon';
import { VoiceDictationModule } from '@vendasta/sales-common';
import { GalaxyLoadingSpinnerModule } from '@vendasta/galaxy/loading-spinner';

@NgModule({
  declarations: [OpportunityNotesComponent, OpportunityNotesEditComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    EmptyStateModule,
    FormsModule,
    GalaxyFormFieldModule,
    GalaxyEmptyStateModule,
    MatIconModule,
    VoiceDictationModule,
    GalaxyLoadingSpinnerModule,
  ],
  exports: [OpportunityNotesComponent],
})
export class OpportunityNotesModule {}
